const messages = {
  dashboard: {
    title: "{name} dashboard",
    extraTitle: "Distributeurs-dashboard",
    description:
      "Welkom in uw dashboard. Hier kunt u actuele cijfers en deelnemende bedrijven uit uw klantenbestand bekijken.",
    overview: {
      title: "Overzicht van deelnemende klanten",
      description:
        "Bedrijven die zich bij BRIDGESTONE <span class='text-danger'>PLUS</span> hebben geregistreerd en die wij via het klantnummer aan u kunnen toewijzen.",
      month: "Aangemaakt voor BS Plus",
      year: "Geregistreerd in BS Plus",
      all: "Totaal",
    },
    credits: {
      title: "Marketingpunten overzicht",
      description:
        "Marketingpunten worden toegekend aan deelnemende bedrijven op basis van de verkoopcijfers die u hebt geüpload.",
      month: "Huidige maand",
      year: "Totaal huidig jaar gekocht",
      prev_year: "Totaal vorig jaar gekocht",
      allDealers: "Alle dealerpunten",
      prev_month: "Vorige maand",
      yearTyre: "Totaal huidig jaar gekocht",
      prev_yearTyre: "Totaal vorig jaar gekocht",
      all: "Totaal",
    },
    details: {
      title: "Deelnemende klanten in detail",
      description:
        "Hieronder vindt u de bedrijven die zich hebben geregistreed op BRIDGESTONE <span class='text-danger'>PLUS</span> met een klantnummer van uw bedrijf.  U kunt kiezen voor een andere sortering of de zoekfunctie gebruiken om klanten op te zoeken.",
    },
    lastImport:
      "Een vertraging tot 5 dagen in de verkoopcijfers <span class='text-danger'>{date}</span>",
    loadMore: "Meer tonen",
    tyres: {
      title: "Banden",
      description: "Banden gekocht door deelnemers aan het programma",
    },
    reload: "Vernieuwen",
  },
};

export default {
  messages,
};
